module.exports = __webpack_public_path__ + "img/filter-line-white.8225f55c.svg";